import StylesProps from '../interfaces/StylesProps';
import StylesContext from './StylesContext';
import { useState, useMemo, ReactNode } from 'react';

interface StylesProviderProps {
  children: ReactNode;
}

function StylesProvider({ children }: StylesProviderProps) {
  const [styles, setStyles] = useState<StylesProps>({
    menuId: 0,
    urlId: '',
    bgColor: '',
    bgLogoColor: '',
    btnBgColor: '',
    btnCircleColor: '',
    btnColor: '',
    logoImg: '',
    textColor: '',
    topTextColor: '',
    footerColor: '',
    bgCategoryContainer: '',
    menuIconColor: '',
    secondaryTextColor: '',
    btnPrevNext: '', 
    btnAddChart: '',
  });

  const stylesContextValues = useMemo(() => ({
    styles,
    setStyles
  }), [styles]);

  return (
    <StylesContext.Provider value={ stylesContextValues }>
      { children }
    </StylesContext.Provider>
  )
}

export default StylesProvider;